import { useEffect, useState } from "react";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import { Eye } from "react-feather";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import AdminBookingNavbar from "./AdminBookingNavbar";

function AdminStaffReport() {
  const [staffData, setStaffData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch staff data from API
  const fetchStaffData = async () => {
    try {
      const response = await axios.get(`${baseurl}/getAllStaff`);
      console.log("API Response:", response.data);

      if (response.data.staff) {
        setStaffData(response.data.staff);
      } else {
        setStaffData([]);
      }
    } catch (error) {
      console.error("Error fetching staff data:", error);
      setError("Failed to load staff data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaffData();
  }, []);

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <AdminBookingNavbar />

              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">Staff Report</h2>
                </div>

                {/* Show loading or error */}
                {loading && <p>Loading staff data...</p>}
                {error && <p className="text-danger">{error}</p>}

                {!loading && !error && (
                  <div className="row g-2 mt-0 mb-0">
                    <div className="col-md-12 p-2">
                      {/* Table */}
                      <div className="table-responsive classic-table">
                        <table className="table table-striped table-hover">
                          <thead className="table-header">
                            <tr>
                              <th>#</th>
                              <th>Staff ID</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone</th>
                              <th>Role</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {staffData.length > 0 ? (
                              staffData.map((staff, index) => (
                                <tr key={staff.id}>
                                  <td>{index + 1}</td>
                                  <td>{staff.admin_unique_id}</td>
                                  <td>{staff.name}</td>
                                  <td>{staff.email}</td>
                                  <td>{staff.phone}</td>
                                  <td>{staff.role}</td>
                                  <td>
                                    <span className={`badge 
                                      ${staff.admin_status === "active" ? "bg-success" : "bg-danger"}
                                    `}>
                                      {staff.admin_status}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="btn2 me-2" title="View Details">
                                      <Eye size={15} />
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center">
                                  No staff found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminStaffReport;
